import { render, staticRenderFns } from "./ImportStepTwo.vue?vue&type=template&id=34664a4b&"
import script from "./ImportStepTwo.vue?vue&type=script&lang=js&"
export * from "./ImportStepTwo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports